import React, { useState, useEffect, useMemo,useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import "./FinalPage.css";
import "../Dashboard/Dashboard.css";
import "../ResultAll/ResultAll.css";

import { useParams } from "react-router-dom";
import "../AsmDetail/AsmDetail.css";
import Dashboard from '../Dashboard/Dashboard'
import bear from "../../images/f1.jpg";
import loadimg from "../../images/loader_wish.gif";
import { END_URL, IMG_URL } from "../../config";
import axios from 'axios';
import ResultChart from '../ResultChart/ResultChart';
import Subscriptions from '../Subscriptions/Subscriptions';
import ResultPageLast from '../ResultPageLast/ResultPageLast';
import ResultSlider from '../ResultSlider/ResultSlider';

function AdminPage({ onLoginChange }) {
    const { result } = useParams();
    const [dimension, setDimension] = useState(null);
    const [badge, setBadge] = useState(null);
    const [cluster, setCluster] = useState(null);
    const [test, setTest] = useState(null);
    const [existingResult, setExistingResult] = useState(null);
    const [resultDetails, setResultDetails] = useState([]);
    const [HavePastTest, setHavePastTest] = useState(false);

    const [resultReady, setResultReady] = useState(false);

    const [testData, settestData] = useState([]);
    
    const [Opacity, setOpacity] = useState(true);
    
    const [SubPlan, setSubPlan] = useState({});

    const TestDone = useRef(null);

    const token = 'admin_token';


    const contentRefs = useRef([]);
    
    const handleFocus = (index) => {
        contentRefs.current[index]?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    useEffect(() => {

        FetchResultDatas();

    }, [result]);


    const result_letter = useMemo(() => {
        if (!Array.isArray(testData?.data)) return [];
        
        return testData.data.map(item =>
            item?.letter === 'left' ? item?.leftletter || "" : item?.rightletter || ""
        );
    }, [testData]);

    useEffect(() => {

        if (Array.isArray(resultDetails) && resultDetails.length > 0) {

            setResultReady(true);
        }
    }, [resultDetails]);


    const [tierData, setTierData] = useState([]);
      
        useEffect(() => {

        const fetchTiers = async () => {

            try {

            const res = await fetch(`${END_URL}/trait-tiers`);

            const data = await res.json();

            setTierData(data);
            } catch (err) {

            console.error("Failed to load tier data", err);
            }
        };

        fetchTiers();
        }, []);

    const FetchResultDatas = async () => {
        try {
            const response = await fetch(`${END_URL}/admin-result-final/${result}`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
            });
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            const data = await response.json();
            setDimension(data.dimension);
            setCluster(data.cluster);
            setBadge(data.badge);
            setTest(data.test);
            setExistingResult(data.existing_result);
            setResultDetails(data.result_details);

            const test = {
                test: {
                    id: data?.test?.id || null,
                    name: data?.test?.name || "",
                    type: data?.test?.type || "",
                    slug: data?.test?.slug || "",
                    test_slug: data?.data?.test_slug || "",
                    result_test_name:  data.test.result_test_name || ""
                }
            };

            const resultdata = {
                data: data?.data?.categoryresult?.map((item) => ({
                    category_id: item?.id || null,
                    left_result: item?.left_result || 0,
                    leftlabel: item?.resultcategory?.left_label || "",
                    leftletter: item?.resultcategory?.leftletter || "",
                    letter: item?.letter || "",
                    name: item?.name || "",
                    right_result: item?.right_result || 0,
                    rightlabel: item?.resultcategory?.right_label || "",
                    rightletter: item?.resultcategory?.rightletter || ""
                })) || []
            };

            const ConvertedtestData = {
                ...resultdata,
                result: data?.data?.result || null,
                ...test
            };

            settestData(ConvertedtestData);


        } catch (error) {

            console.error("Error sending result:", error);

         }
        finally {

            setIsLoading(false);
        }
    };

    const handleSliderImageLoaded = () => {
        setResultReady(true);
    };

    const [isLoading, setIsLoading] = useState(true);


    return(
            isLoading || !resultReady ? (

            <div className="loader-container">

                <img src={loadimg} alt="Loading..." className="loader-gif" />

            </div>
        ) : (

            <div className="final-main result-cont">

                <ResultSlider dimension={dimension} onImageLoadComplete={handleSliderImageLoaded} />

                <div className="container-fluid">
                    <div className="row result-cont-row admin-side-freeResult">

                    
                         <div className="col-12 col-sm-12 col-md-9 col-lg-9 final-col">

                            <div className="final-col-inner">
                                {(() => {
                                    const groupedElements = [];
                                    let buffer = [];

                                    const isExtendSection = (classStr) => classStr.split(" ").includes("extend_section");

                                    resultDetails.forEach((item, index) => {
                                        const contentTypeClass = item.content_type ? item.content_type : "";

                                        const contentDiv = (
                                            <div
                                                className={`final-part1 ${contentTypeClass}`}
                                                ref={(el) => (contentRefs.current[index] = el)} 
                                                key={item.id}
                                                dangerouslySetInnerHTML={{ __html: item.content }}
                                            />
                                        );

                                        if (isExtendSection(contentTypeClass)) {
                                            buffer.push(contentDiv);
                                        } else {
                                            if (buffer.length > 0) {
                                                groupedElements.push(
                                                    <div className="extend-common" key={`group-${index}`}>
                                                        {buffer}
                                                    </div>
                                                );
                                                buffer = [];
                                            }

                                            groupedElements.push(contentDiv);
                                        }
                                    });

                                    if (buffer.length > 0) {
                                        groupedElements.push(
                                            <div className="extend-common" key="group-end">
                                                {buffer}
                                            </div>
                                        );
                                    }

                                    return groupedElements;
                                })()}
                            </div>

                            
                        </div>

                        <div className='col-12 col-sm-12 col-md-9 col-lg-9 final-subs-admin'>

                             {testData?.test && result_letter.length > 0  && <ResultChart resultRef={TestDone} onLoginChange={onLoginChange} past_test={HavePastTest} subplan={SubPlan} token={token} result={result_letter} testdata={testData} demension={dimension} opacity={Opacity} tierData={tierData} />}

                            <div className="free-unpaid-res">

                                    <ResultPageLast
                                        type="result"
                                        onLoginChange={onLoginChange}
                                        token={token}
                                        payment={''}
                                        slug={''}
                                        demension={dimension}
                                    />
                            </div>

                        </div>

                       
                    </div>
                </div>
            </div>
        )
    );
}

export default AdminPage;
